import { FC, useCallback } from 'react';
import PopUpContentWrapper from 'src/components/PopUpContentWrapper';
import Button from 'src/components/design-system/Button';
import PopUp from 'src/components/design-system/PopUp';
import useCancelPoApi from 'src/services/useCancelPoApi';
import { useContextSelector } from 'use-context-selector';
import { PoRelatedDocumentsContext } from '../po_related_documents/PoRelatedDocumentsContext';
import { InvoiceContext } from './InvoiceDetailsContext';
import usePoButtonState from './usePoButtonState';

interface CancelPoProps {}

const CancelPo: FC<CancelPoProps> = () => {
  const poId = useContextSelector(InvoiceContext, (value) => value.poId);
  const refreshPage = useContextSelector(InvoiceContext, (value) => value.refreshPage);
  const isInvoiceActionButtonDisabled = useContextSelector(
    InvoiceContext,
    (value) => value.isInvoiceActionButtonDisabled
  );
  const getMessages = useContextSelector(InvoiceContext, (value) => value.getMessages);

  const poDetails = useContextSelector(PoRelatedDocumentsContext, (value) => value.poDetails);
  const { cancelPo, cancelPoCallLoading } = useCancelPoApi();
  const [cancelPoMessage, cancelPoButtonState] = usePoButtonState(
    poDetails?.triggerPreCheck || [],
    'Cancel'
  );

  const handleCancelPo = useCallback(async () => {
    try {
      await cancelPo({ poIds: [poId] });
    } finally {
      refreshPage();
    }
  }, [cancelPo, poId, refreshPage]);

  return (
    <PopUp
      popupAlign={{ horizontal: 'center', vertical: 'top' }}
      content={
        <div className="m-1 max-w-[350px]">
          <PopUpContentWrapper
            type="Error"
            contents={getMessages(cancelPoButtonState, cancelPoMessage)}
          />
        </div>
      }
      show={isInvoiceActionButtonDisabled(cancelPoButtonState)}
    >
      <Button
        onClick={handleCancelPo}
        color="error"
        buttonState={cancelPoButtonState}
        disabled={isInvoiceActionButtonDisabled(cancelPoButtonState)}
        loading={cancelPoCallLoading}
      >
        Cancel PO
      </Button>
    </PopUp>
  );
};

export default CancelPo;
